import { IController } from 'angular';
import * as _ from 'lodash';
import { UtilitiesService } from 'src/ng2/shared/services/utilities/utilities.service';
import { SubjectAreas } from '../../../../../ng2/shared/constants/subject-areas.constant';
/* tslint:disable-next-line:max-line-length */
import { StudentPanelPersistance } from '../../../../../ng2/shared/services/student-panel-persistance/student-panel-persistance.service';
import { ITranscriptCourse } from '../../../../../ng2/shared/typings/interfaces/student.interface';

export class StudentFullTranscriptHistoryPanelCtrl implements IController {
  static $inject = ['UtilitiesService', 'StudentPanelPersistance'];

  // Bindings
  private student;

  // local
  private title;
  private tableRows;
  private tableRowsForTable1;
  private tableRowsForTable2;
  private sortBy;

  constructor(private UtilitiesService: UtilitiesService, private StudentPanelPersistance: StudentPanelPersistance) {}

  $onInit() {
    this.title = 'Full Transcript History';

    const transcriptCopy = _.cloneDeep(this.student.creditDetails.transcript);
    this.tableRows = _.map(transcriptCopy, (courseTranscript: ITranscriptCourse) => {
      let subject = courseTranscript.subjectArea;

      let row: any = [
        this.formatSubjectStr(subject),
        courseTranscript.courseCode,
        courseTranscript.courseSchoolId,
        courseTranscript.schoolYear + '/' + courseTranscript.term,
        courseTranscript.creditValue,
        courseTranscript.mark.string,
      ];

      row.subjectSortOrder = this.getSubjectSortOrder(subject);
      row.cssClass = this.getRowCssClass(courseTranscript);
      row.idx = this.UtilitiesService.createV4Uuid();

      return row;
    });
    this.tableRowsForTable1 = _.slice(this.tableRows, 0, Math.ceil(this.tableRows.length / 2));
    this.tableRowsForTable2 = _.slice(this.tableRows, Math.ceil(this.tableRows.length / 2), this.tableRows.length);

    // sort table by subject on init
    this.sortBy = this.StudentPanelPersistance.setInitialSort({
      sortKey: 'fullTranscriptHistorySort',
      sortOptions: {
        sortByTerm: this.sortByTerm.bind(this),
        sortBySubject: this.sortBySubject.bind(this),
        default: 'sortBySubject',
      },
    });
  }

  // methods
  // NG-CHANGE sort
  sort() {
    const sortKey = 'fullTranscriptHistorySort';
    const sortByTerm = 'sortByTerm';
    const sortBySubject = 'sortBySubject';

    if (this.sortBy === sortBySubject) {
      // Temporarilty sorting by couseCode
      this.StudentPanelPersistance.updateAndPersistSort(sortKey, sortBySubject);
      return this.sortBySubject();
    }

    if (this.sortBy === sortByTerm) {
      this.StudentPanelPersistance.updateAndPersistSort(sortKey, sortByTerm);
      return this.sortByTerm();
    }
  }

  // ASCENDING ORDER
  sortBySubject() {
    this.tableRows.sort((a, b) => {
      // 1. Sort by subject sort order
      const subjectSort = this.compareSubjectSortOrder(a.subjectSortOrder, b.subjectSortOrder);
      // 2. Sort by course code
      if (subjectSort === 0) {
        if (a[1] > b[1]) {
          return 1;
        }
        return -1;
      }

      return subjectSort;
    });

    this.tableRowsForTable1 = _.slice(this.tableRows, 0, Math.ceil(this.tableRows.length / 2));
    this.tableRowsForTable2 = _.slice(this.tableRows, Math.ceil(this.tableRows.length / 2), this.tableRows.length);
  }

  // DESCENDING ORDER
  sortByTerm() {
    this.tableRows.sort((a, b) => {
      // 1. Sort by course term
      const termDateSort = this.compareTermDate(a[3], b[3]);
      // 2. Sort by subject sort order
      if (termDateSort === 0) {
        return this.compareSubjectSortOrder(a.subjectSortOrder, b.subjectSortOrder);
      }

      return termDateSort;
    });

    this.tableRowsForTable1 = _.slice(this.tableRows, 0, Math.ceil(this.tableRows.length / 2));
    this.tableRowsForTable2 = _.slice(this.tableRows, Math.ceil(this.tableRows.length / 2), this.tableRows.length);
  }

  compareSubjectSortOrder(subjectSortOrderA, subjectSortOrderB) {
    if (subjectSortOrderA > subjectSortOrderB) {
      return 1;
    } else if (subjectSortOrderA === subjectSortOrderB) {
      return 0;
    }
    return -1;
  }

  compareTermDate(adminDateA, adminDateB) {
    adminDateA = parseInt(adminDateA.replace(/SY|-|\//g, ''));
    adminDateB = parseInt(adminDateB.replace(/SY|-|\//g, ''));

    if (adminDateA > adminDateB) {
      return 1;
    } else if (adminDateA === adminDateB) {
      return 0;
    }
    return -1;
  }

  getRowCssClass(courseTranscript) {
    switch (courseTranscript.passFailEquivalent) {
      case 'P':
        return 'pass';
      case 'F':
        return 'fail';
      default:
        return '';
    }
  }

  formatSubjectStr(subject) {
    const memo = {};

    if (!memo[subject]) {
      const subjectArea = _.find(SubjectAreas, { camelCase: subject });
      const subjectAreaHuman = subjectArea ? subjectArea.human : SubjectAreas.MISC.human;
      return (memo[subject] = subjectAreaHuman);
    }

    return memo[subject];
  }

  getSubjectSortOrder(subject) {
    const subjectArea = _.find(SubjectAreas, { camelCase: subject });
    const subjectAreaSortOrder = subjectArea ? subjectArea.sortOrder : SubjectAreas.MISC.sortOrder + 1;
    return subjectAreaSortOrder;
  }
}

angular
  .module('nv.singleStudent')
  .controller('StudentFullTranscriptHistoryPanelCtrl', StudentFullTranscriptHistoryPanelCtrl);
